<div class="patientIintakeSuccess">
    <h1>Patient Added Successfully</h1>
    <button mat-button (click)="onNoClick()">Add New </button>
    <button mat-button (click)="onBackClick()">Dashboard</button>

    <span (click)="onBackClick()" class="close-btn-modal material-icons">	<mat-icon>close</mat-icon></span>


</div>